import * as Sentry from '@sentry/react';
import type { ComponentType, ReactNode } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

import { ErrorFallback } from '@/components/ui/ErrorFallback';
import { isChunkLoadError } from '@/lib/lazyWithRetry';

type Props = {
    children: ReactNode;
    FallbackComponent?: ComponentType<FallbackProps>;
    resetKeys?: unknown[];
    boundaryName?: string;
};

export function ReportingErrorBoundary({
    children,
    FallbackComponent = ErrorFallback,
    resetKeys,
    boundaryName,
}: Props) {
    return (
        <ErrorBoundary
            FallbackComponent={FallbackComponent}
            resetKeys={resetKeys}
            onError={(error, info) => {
                const errorType = isChunkLoadError(error)
                    ? 'chunk_load_error'
                    : 'react_error_boundary';
                Sentry.captureException(error, {
                    tags: {
                        errorType,
                        ...(boundaryName ? { boundary: boundaryName } : {}),
                    },
                    contexts: {
                        react: { componentStack: info.componentStack ?? undefined },
                    },
                });
            }}
        >
            {children}
        </ErrorBoundary>
    );
}
